import { useEffect, useMemo } from "react"
import { Node } from '@antv/x6'
import { svgStrToDataUrl } from "@/common/svg"
import { NozzleType } from "@/types/common"
import { Flip, NodeState } from "../services/modal"
import { useEditorEventBusInstance } from "../events/useEventBusInstance"
import { NozzleEdge } from "./NozzleEdge"
import { useUpdateEffect } from "ahooks"
import { PortTypes } from "../constant"
import classNames from "classnames"
import { SvgElem } from "@/components/SvgElem/SvgElem"
import { useCellStatusClassName } from '../plugins/UnitSimPlugin/CellsSimHooks'


export const SvgNode = ({node}: {node: Node}) => {
  const data: NodeState = node.getData()
  const { width, height } = node!.getSize()
  const {nozzles, image, nozzleEdges, flip } = data;
  const eventBus = useEditorEventBusInstance()
  const flowNozzles = nozzles.filter(item => item.layout && item.image && item.type === NozzleType.FlowNozzle)
  const nodeId = node.id;
  const statusClassName = useCellStatusClassName(nodeId)

  const flowNozzleElems = useMemo(() => {
    return flowNozzles
      .map((item) => {
        const { width: fW = 20, height: fH = 20, angle = 0, x, y } = item.layout!
        const styles = {
          width: fW,
          height: fH,
          left: x * width,
          top: y * height - fH / 2,
          transformOrigin: 'center left',
          transform: `rotate(-${angle}deg)`
        }

        return <img className='fs-nozzle' src={svgStrToDataUrl(item.image!)} key={item.id} style={styles} />
      })
  }, [flowNozzles, width, height])

  const nozzleLines = useMemo(() => {
    return (nozzleEdges || []).map(item => {
      return <NozzleEdge key={JSON.stringify(item)} node={node} width={width} height={height} nozzleEdge={item} eventBus={eventBus} />
    })
  }, [nozzleEdges, width, height])

  const flipClassName = useMemo(() => {
    if (flip === Flip.X) return 'node-flip-x';
    if (flip === Flip.Y) return 'node-flip-y';
    return ''
  }, [flip])

  useUpdateEffect(() => {
    const autoNozzles = nozzles.filter(item => item.group !== PortTypes.SvgNozzlePort)
    if (flip === Flip.X) {
      autoNozzles.forEach((nozzle) => {
        node.portProp(nozzle.id, 'args/y', 1 - nozzle.layout!.y || 0)
        node.portProp(nozzle.id, 'args/x', nozzle.layout!.x || 0)
      })
    } else if (flip === Flip.Y) {
      autoNozzles.forEach((nozzle) => {
        node.portProp(nozzle.id, 'args/x', 1 - nozzle.layout!.x || 0)
        node.portProp(nozzle.id, 'args/y', nozzle.layout!.y || 0)
      })
    } else {
      autoNozzles.forEach((nozzle) => {
        node.portProp(nozzle.id, 'args/y', nozzle.layout!.y || 0)
        node.portProp(nozzle.id, 'args/x', nozzle.layout!.x || 0)
      })
    }
  }, [flip, nozzles, node])

  return <div className={classNames('fs-node', statusClassName)} style={{
    position: 'relative',
    width: '100%',
    height: '100%',
  }}>
    <SvgElem className={classNames('fs-svg-node shake-node', flipClassName)} imageStr={image} />
    {/* <div className={classNames(flipClassName)} dangerouslySetInnerHTML={{__html: imageElem}} style={{width: '100%', height: '100%'}}></div> */}
    {/* <img className={classNames(flipClassName, 'svg-image')} src={svgStrToDataUrl(imageElem)} style={{ width: '100%', height: '100%' }} key={node.id} /> */}
    {nozzleLines}
    {flowNozzleElems}
  </div>
}

